import { createContext, useContext } from 'react';
import { WebsiteEditorContextProps } from './WebsiteEditor.types';

export const WebsiteEditorContext = createContext<WebsiteEditorContextProps | undefined>(undefined);

export const useWebsiteEditorContext = () => {
  const context = useContext(WebsiteEditorContext);
  if (context === undefined) {
    throw new Error('useWebsiteEditorContext must be used within a WebsiteEditorProvider');
  }
  return context;
};
